'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.events = exports.Events = exports.SessionCode = void 0;
var tslib_1 = require("tslib");
var pubsub_1 = require("../events/pubsub");
var balance_1 = require("../util/balance");
var SessionCode;
(function (SessionCode) {
    SessionCode[SessionCode["LOGGED_IN"] = 0] = "LOGGED_IN";
    SessionCode[SessionCode["EXPIRED"] = 1] = "EXPIRED";
    SessionCode[SessionCode["LOGGED_OFF"] = 2] = "LOGGED_OFF";
    SessionCode[SessionCode["TERMINATED_BY_ANOTHER_LOGIN"] = 3] = "TERMINATED_BY_ANOTHER_LOGIN";
    SessionCode[SessionCode["TERMINATED_BY_PRESET_TIME"] = 5] = "TERMINATED_BY_PRESET_TIME";
    SessionCode[SessionCode["TERMINATED_BY_SELF_EXCLUSION"] = 6] = "TERMINATED_BY_SELF_EXCLUSION";
    SessionCode[SessionCode["TERMINATED_BY_GEO_LOCATION"] = 7] = "TERMINATED_BY_GEO_LOCATION";
})(SessionCode = exports.SessionCode || (exports.SessionCode = {}));
var Events = /** @class */ (function () {
    function Events() {
        var _a;
        this.API2SDKTopicsMap = {
            balanceChanged: pubsub_1.Topic.BalanceChanged,
            achievement: pubsub_1.Topic.AchievementUnlocked,
            categoriesPublish: pubsub_1.Topic.CategoriesPublished,
            delayedReward: pubsub_1.Topic.DelayedReward,
            firstdeposit: pubsub_1.Topic.FirstDeposit,
            leaderboardPayout: pubsub_1.Topic.LeaderboardPayout,
            maintenance: pubsub_1.Topic.MaintenanceChanged,
            KYCUpdate: pubsub_1.Topic.KYCStatusUpdated,
            reward: pubsub_1.Topic.RewardReceived,
            relicPrizeAwarded: pubsub_1.Topic.RelicPrizeAwarded,
            sessionChange: pubsub_1.Topic.SessionChanged,
            subsequentdeposit: pubsub_1.Topic.SubsequentDeposit,
            translationsPublish: pubsub_1.Topic.TranslationsPublished,
            userUpdate: pubsub_1.Topic.UserUpdated,
            userDataRequired: pubsub_1.Topic.UserDataRequired,
            withdrawStatusChange: pubsub_1.Topic.WithdrawStatusChanged,
            wsConnected: pubsub_1.Topic.WSOpen,
            wsDisconnected: pubsub_1.Topic.WSClose,
            message: pubsub_1.Topic.Message,
            userBlockStatus: pubsub_1.Topic.UserBlockStatus,
            loyaltyPointsUpdate: pubsub_1.Topic.LoyaltyPointsUpdate,
            gameSessionSummary: pubsub_1.Topic.GameSessionSummary,
            lotbaUserSelfExcludedOnOldRegister: pubsub_1.Topic.LotbaUserSelfExcludedOnOldRegister,
            gameTransaction: pubsub_1.Topic.GameTransaction,
            user_profile_wallet_updated: pubsub_1.Topic.BalanceChangedCoreX,
            user_profile_updated: pubsub_1.Topic.UserProfileUpdatedCoreX,
            reality_check_updated: pubsub_1.Topic.RealityCheckUpdatedX,
            verification_documents: pubsub_1.Topic.VerificationDocumentsUpdatedX,
        };
        this.sessionCodes2Topics = (_a = {},
            _a[SessionCode.LOGGED_IN] = pubsub_1.Topic.SessionCreated,
            _a[SessionCode.EXPIRED] = pubsub_1.Topic.SessionExpired,
            _a[SessionCode.LOGGED_OFF] = pubsub_1.Topic.SessionLoggedOut,
            _a[SessionCode.TERMINATED_BY_ANOTHER_LOGIN] = pubsub_1.Topic.SessionKickedOut,
            _a[SessionCode.TERMINATED_BY_PRESET_TIME] = pubsub_1.Topic.SessionLimitationTimeReached,
            _a[SessionCode.TERMINATED_BY_SELF_EXCLUSION] = pubsub_1.Topic.SessionSelfExclusion,
            _a[SessionCode.TERMINATED_BY_GEO_LOCATION] = pubsub_1.Topic.SessionGeoLocation,
            _a);
        this.legacyEvents = ['loggedIn'];
    }
    Events.prototype.delayedReward = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.DelayedReward, handler);
    };
    Events.prototype.leaderboardPayout = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.LeaderboardPayout, handler);
    };
    Events.prototype.relicPrizeAwarded = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.RelicPrizeAwarded, handler);
    };
    Events.prototype.rewardReceived = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.RewardReceived, handler);
    };
    Events.prototype.subsequentDeposit = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SubsequentDeposit, handler);
    };
    Events.prototype.firstDeposit = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.FirstDeposit, handler);
    };
    Events.prototype.achievementUnlocked = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.AchievementUnlocked, handler);
    };
    Events.prototype.maintenanceChanged = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.MaintenanceChanged, handler);
    };
    Events.prototype.userUpdated = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.UserUpdated, handler);
    };
    Events.prototype.userBlockStatusChanged = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.UserBlockStatus, handler);
    };
    Events.prototype.translationsPublished = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.TranslationsPublished, handler);
    };
    Events.prototype.categoriesPublished = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.CategoriesPublished, handler);
    };
    Events.prototype.userDataRequired = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.UserDataRequired, handler);
    };
    Events.prototype.KYCStatusUpdated = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.KYCStatusUpdated, handler);
    };
    Events.prototype.balanceChanged = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.BalanceChanged, handler);
    };
    Events.prototype.computedBalanceChanged = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.BalanceChanged, function (event) {
            var newBalance = {
                balance: 0,
                realBalance: event.amount,
                bonusBalance: 0,
                bonusBonusMoneyBalance: 0,
                bonusRealMoneyBalance: 0,
            };
            event.userBonus.forEach(function (product) {
                newBalance.bonusBonusMoneyBalance += product.bonuses.reduce(function (prev, item) { return prev + item.bonusMoney; }, 0);
                newBalance.bonusRealMoneyBalance += product.bonuses.reduce(function (prev, item) { return prev + item.realBonusMoney; }, 0);
            });
            newBalance.bonusBalance =
                newBalance.bonusBonusMoneyBalance +
                    newBalance.bonusRealMoneyBalance;
            newBalance.balance =
                newBalance.realBalance + newBalance.bonusBalance;
            handler(newBalance);
        });
    };
    Events.prototype.computedBalanceChangedCoreX = function (accounts, handler) {
        var updatedAccounts = tslib_1.__spreadArray([], tslib_1.__read(accounts));
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.BalanceChangedCoreX, function (event) {
            var index = updatedAccounts.findIndex(function (account) { return account.walletId === event.WalletId; });
            var updatedAccount = balance_1.mapToAccount(event);
            if (index !== -1) {
                updatedAccounts[index] = updatedAccount;
            }
            else {
                updatedAccounts.push(updatedAccount);
            }
            handler(updatedAccounts, updatedAccount);
        });
    };
    Events.prototype.accountChangedCoreX = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.BalanceChangedCoreX, function (event) {
            var mappedAccount = balance_1.mapToAccount(event);
            handler(mappedAccount);
        });
    };
    Events.prototype.withdrawStatusChanged = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.WithdrawStatusChanged, handler);
    };
    Events.prototype.sessionChange = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionChanged, handler);
    };
    Events.prototype.sessionCreated = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionCreated, handler);
    };
    Events.prototype.sessionDestroyed = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionDestroyed, handler);
    };
    Events.prototype.sessionDestroyedCoreX = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionDestroyedCoreX, handler);
    };
    Events.prototype.sessionExpired = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionExpired, handler);
    };
    Events.prototype.sessionKickedOut = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionKickedOut, handler);
    };
    Events.prototype.sessionLimitationTimeReached = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionLimitationTimeReached, handler);
    };
    Events.prototype.sessionSelfExclusion = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionSelfExclusion, handler);
    };
    Events.prototype.sessionGeoLocation = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SessionGeoLocation, handler);
    };
    Events.prototype.wsConnected = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.WSOpen, handler);
    };
    Events.prototype.wsDisconnected = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.WSClose, handler);
    };
    Events.prototype.message = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.Message, function (message) {
            return handler(tslib_1.__assign(tslib_1.__assign({}, message), { 
                // there's no created date returned from the event
                // https://gaminginnovationgroup.atlassian.net/projects/MAGIC/issues/MAGIC-226
                // TODO: remove when fixed in API
                created: message.created || new Date().toISOString() }));
        });
    };
    Events.prototype.sowqRequested = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.SOWQRequested, handler);
    };
    Events.prototype.distribute = function (topic, payload) {
        var sdkTopic = this.API2SDKTopicsMap[topic];
        if (this.legacyEvents.includes(topic)) {
            return;
        }
        if (!sdkTopic) {
            return console.error("Unknown topic: " + topic);
        }
        if (sdkTopic === pubsub_1.Topic.SessionChanged) {
            return this.distributeSessionEvent(payload);
        }
        pubsub_1.pubsub.publish(sdkTopic, payload);
    };
    Events.prototype.loyaltyPointsUpdate = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.LoyaltyPointsUpdate, handler);
    };
    Events.prototype.gameSessionSummary = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.GameSessionSummary, handler);
    };
    Events.prototype.lotbaUserSelfExcludedOnOldRegister = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.LotbaUserSelfExcludedOnOldRegister, handler);
    };
    Events.prototype.gameTransaction = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.GameTransaction, handler);
    };
    Events.prototype.distributeSessionEvent = function (payload) {
        var sdkTopic = this.sessionCodes2Topics[payload.code];
        if (!sdkTopic) {
            return console.error("Unknown session code: " + sdkTopic);
        }
        if (sdkTopic !== pubsub_1.Topic.SessionCreated &&
            sdkTopic !== pubsub_1.Topic.SessionDestroyed) {
            pubsub_1.pubsub.publish(sdkTopic);
        }
        pubsub_1.pubsub.publish(pubsub_1.Topic.SessionChanged, payload.code);
    };
    Events.prototype.userProfileUpdated = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.UserProfileUpdatedCoreX, handler);
    };
    Events.prototype.realityCheckUpdated = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.RealityCheckUpdatedX, handler);
    };
    Events.prototype.verificationDocumentsUpdated = function (handler) {
        return pubsub_1.pubsub.subscribe(pubsub_1.Topic.VerificationDocumentsUpdatedX, handler);
    };
    return Events;
}());
exports.Events = Events;
exports.events = new Events();
